import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem } from '@knockrentals/knock-shared-web';
import {
  ACTIVATE_SELECTED_LABEL,
  ACTIVATION_STATUS,
  BULK_UPDATE_LABEL,
  DEACTIVATE_SELECTED_LABEL,
} from './constants';

const BulkUpdateMenu = ({ count, handleBulkSettingsUpdate }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuItemOnClick = (activationStatus) => () => {
    handleBulkSettingsUpdate(activationStatus);
    handleMenuClose();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Button
        color="primary"
        disabled={count < 2}
        onClick={handleMenuOpen}
        variant="text"
      >
        {BULK_UPDATE_LABEL} ({count})
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        keepMounted
      >
        <MenuItem onClick={handleMenuItemOnClick(ACTIVATION_STATUS.ACTIVE)}>
          {ACTIVATE_SELECTED_LABEL}
        </MenuItem>
        <MenuItem onClick={handleMenuItemOnClick(ACTIVATION_STATUS.INACTIVE)}>
          {DEACTIVATE_SELECTED_LABEL}
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

BulkUpdateMenu.propTypes = {
  count: PropTypes.number.isRequired,
  handleBulkSettingsUpdate: PropTypes.func.isRequired,
};

export default BulkUpdateMenu;
